import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "left_menu" }
const _hoisted_2 = { class: "left_gnb" }
const _hoisted_3 = { class: "depth_01" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "menu_icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "depth_02"
}
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menus, (menu, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: idx,
            class: _normalizeClass([menu.isActive ? 'active' : '']),
            onClick: ($event: any) => (!menu.child ? $setup.router.push({ name: menu.path }) : '')
          }, [
            (
                            menu.isHasAuth === undefined ||
                            (menu.isHasAuth === false && $setup.user.userInfo.auth !== 8 && $setup.user.userInfo.auth !== 7 && menu.path !== 'desk_for_7') ||
                            (menu.isHasAuth === true && $setup.user.userInfo.auth === 8) ||
                            (menu.isHasAuth === false && $setup.user.userInfo.auth === 7 && menu.path === 'desk_for_7')
                        )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_5, [
                      (!menu.isActive)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: menu.thumbnailPath,
                            alt: ""
                          }, null, 8, _hoisted_6))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: menu.thumbnailPathActive,
                            alt: ""
                          }, null, 8, _hoisted_7))
                    ]),
                    _createElementVNode("p", {
                      innerHTML: menu.name
                    }, null, 8, _hoisted_8)
                  ]),
                  (menu.child)
                    ? _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.child, (childMenu, childIdx) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: childIdx,
                            class: _normalizeClass({ active: childMenu.isActive }),
                            onClick: ($event: any) => ($setup.router.push({ name: childMenu.path }))
                          }, _toDisplayString(childMenu.name), 11, _hoisted_10))
                        }), 128))
                      ], 512)), [
                        [_vShow, true]
                      ])
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 10, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}